// extracted by mini-css-extract-plugin
export var content = "_n8-1";
export var fullScreen = "_n8-0";